import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../../core/services/api.service';
import { ApiResponse } from '../../../core/shared/classes/api';


@Injectable()
export class AgendaService {

    constructor (private apiService: ApiService) {}

    getRendezVous(id?: string, debut?: string, fin?: string, userIds?: string): Observable<ApiResponse> {
        return this.apiService.get('agenda'
            + (id ? '/rdv/' + id : '')
            + (debut ? '/debut/' + debut : '')
            + (fin ? '/fin/' + fin : '')
            + (userIds ? '/users/' + userIds : '')
        );
    }

    updateRendezVous(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('agenda/rdv/' + id, data);
    }

    insertRendezVous(data: any): Observable<ApiResponse> {
        return this.apiService.post('agenda/rdv', data);
    }

    deleteRdv(id: string): Observable<ApiResponse> {
        return this.apiService.delete('agenda/rdv/' + id);
    }

    getTodayRdv(): Observable<ApiResponse> {
        return this.apiService.get('agenda/rdv/today-count');
    }

    getTypesRdv(): Observable<ApiResponse> {
        return this.apiService.get('agenda/type-rdv');
    }

    updateTypeRdv(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('agenda/type-rdv/' + id, data);
    }

    insertTypeRdv(data: any): Observable<ApiResponse> {
        return this.apiService.post('agenda/type-rdv', data);
    }

    deleteTypeRdv(id: string): Observable<ApiResponse> {
        return this.apiService.delete('agenda/type-rdv/' + id);
    }

    synchronizeRdv(userId?: string, debut?: string, fin?: string): Observable<ApiResponse> {
        return this.apiService.get('agenda/rdv/synchronize'
            + (userId ? '/user/' + userId : '')
            + (debut ? '/debut/' + debut : '')
            + (fin ? '/fin/' + fin : '')
        );
    }

    updateOccurrenceRendezVous(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.put('agenda/rdv/update-occurrence/' + id, data);
    }

    deleteOccurrenceRendezVous(id: string, data: any): Observable<ApiResponse> {
        return this.apiService.post('agenda/rdv/delete-occurrence/' + id, data);
    }
}
